import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserModel } from '@shared/models/user.model';

@Component({
    standalone: false,
    selector   : 'particle-manage-participants-dialog',
  templateUrl: './manage-participants-dialog.component.html',
  styleUrls  : ['./manage-participants-dialog.component.scss']
})
export class ManageParticipantsDialogComponent implements OnInit {
  public participants: UserModel[];
  public disableDoneButton: boolean;

  constructor (public manageParticipantsDialogComponent: MatDialogRef<ManageParticipantsDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               private formBuilder: FormBuilder) {
    this.participants = data.participants;
    this.disableDoneButton = true;
  }

  ngOnInit () {
  }

  onSelectionChanged ($event: any[]) {
    console.log($event);
    this.disableDoneButton = false;
    this.participants = $event.map(participant => participant.user);
  }

  onCancel () {
    this.manageParticipantsDialogComponent.close();
  }

  onDone () {
    this.manageParticipantsDialogComponent.close(this.participants);
  }
}
